import PathwayInstanceSummaryContainer from './pathway_instance_summary_container';

const PathwayInstanceSummary = PathwayInstanceSummaryContainer;
export default PathwayInstanceSummary;
